import React from 'react';
import styled from 'styled-components';
import HpPopup from '../common/popup/HpPopup';
import { getPopUpAction } from "../../modules/cs/customserviceModule";
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import style from '../../../node_modules/dom-helpers/cjs/css';
import {isMobileOnly} from 'react-device-detect';

const HpPopUpContainerBlock = styled.div`
    display: ${props => props.display};
    ${isMobileOnly?`  
    `:`
    position: relative;
    width: 1176px;
    margin: 0 auto;
    `};

    
`;

const HpPopUpContainer2Block = styled.div`
    width: 620px;
`;


const baseX = isMobileOnly?0:-2;
const baseY = isMobileOnly?35:320;
const unitX = isMobileOnly?"vw":"vw";
const unitY = isMobileOnly?"vh":"px";
const offsetX = isMobileOnly?40:290;
const offsetY = isMobileOnly?0:0;

const HpPopUpItemsBlock = styled.div`
    display: ${props => props.display};
    position: absolute;
    z-index: ${props=>parseInt(props.id)*10+30};
    top: ${props=>`${props.id*offsetY+baseY}${unitY}`};
    left: ${props=>`${parseInt(props.id)*offsetX+baseX}${parseInt(props.id)>0? (isMobileOnly? unitX: 'px'):unitX}`};
`;

const HpPopUpItem1Block = styled.div`
    display: ${props => props.display};
    position: absolute;
    z-index: 30;
    // top: 500px;
    // left: 212px;
    top: 40vh;
    left: 10vw;

`;

const HpPopUpItem2Block = styled.div`
    display: ${props => props.display};
    //display: inline-block;
    // float : right;
    // margin-left : 30px;
    // position:relative;
    position: absolute;
    z-index: 40;
    // top: 500px;
    // left: 212px;
    top: 45vh;
    left: 15vw;
    
       
`;

/* const BrandHomeStickyHeaderFirstBlock = styled.div`
    display: block;
    position: fixed;
    top: 80px;
    left: 0;
    width: 100%;
    height: 50px;
    padding: 18px 0;
    background-color: #ffc742;
    z-index: 10;
`; */

const FIRST_POPUP = "FIRST_POPUP"
const SECOND_POPUP = "SECOND_POPUP"

const HpPopUpContainer = () => {
    const [display, setDisplay] = useState(false);
    const dispatch = useDispatch();
    const [close1, setClose1] = useState(true);
    const [close2, setClose2] = useState(true);
    const [updatePopUp, setUpdatePopUp] = useState([]);

    const { popUpData } = useSelector(
        ({ customserviceReducer }) => ({
            popUpData: customserviceReducer.popUpData
        })
    );
    const popUps = [];

    useEffect(() => {
        if(popUpData === null){
            if(!isMobileOnly){
                let param = '?isMobile=0&limit=2'
                dispatch(getPopUpAction(param));
            }
        }

        if(popUpData != null && popUpData.length > 0){
            //console.log("popUpData = " + JSON.stringify(popUpData))
            var todayDate = new Date();
            var updateData = [];

            for(var  i = 0; i < popUpData.length && i < 2; i++){

                var name = popUpData[i].landing_url + todayDate.getDate();
                var cookie = getCookie(name);

                if(cookie === "1"){

                }
                else {
                    updateData.push(popUpData[i]);
                }
            }

            if(updateData && updateData.length > 0){

                if(updateData.length === 2){
                    setClose1(false);
                    setClose2(false);
                }
                else if(updateData.length === 1){
                    setClose1(false);
                }

                setDisplay(true);

            }

            setUpdatePopUp(updateData);
        }

    }, [popUpData]);

    const setCookie = (name, value, expiredays) => {
        var todayDate = new Date();
        let valueSave = name+todayDate.getDate();
        todayDate.setDate(todayDate.getDate() + expiredays);
        //console.log("valueSave = "+ valueSave)
        document.cookie = valueSave + '=' + escape(value) + '; path=/; expires=' + todayDate.toGMTString() + ';';
    }

    const getCookie = (name) => {
        var cookiedata = document.cookie;
        var obj = name + "=";

        var x = 0;

        while ( x <= document.cookie.length )
        {
            var y = (x+obj.length);
            var endOfCookie;
            if ( document.cookie.substring( x, y ) == obj )
            {
                if ((endOfCookie=document.cookie.indexOf( ";", y )) == -1 )
                    endOfCookie = document.cookie.length;

                return unescape( document.cookie.substring( y, endOfCookie ) );
            }

            x = document.cookie.indexOf( " ", x ) + 1;

            if ( x == 0 )
                break;

        }

        return "";
    }

    const handlePopupClose = (index, isDayNoShow) => {

        //console.log("index = " + index + "isDayNoShow = " + isDayNoShow)
        if(index === 0){
            if(isDayNoShow){
                //setCookie(FIRST_POPUP, updatePopUp[0].landing_url, 1);
                setCookie(updatePopUp[0].landing_url, "1", 1);
            }

            setClose1(true);
        }
        else {
            if(isDayNoShow){
                //setCookie(SECOND_POPUP, updatePopUp[1].landing_url, 1)
                setCookie(updatePopUp[1].landing_url, "1", 1)
            }
            setClose2(true);

        }
    }

    if(display === false){
        return <HpPopUpContainerBlock/>;
    }

    for(const [index,obj] of updatePopUp.entries()){
        const close = index===0?close1:close2;
        if(index>1) return;
        popUps.push(
          <HpPopUpItemsBlock key={index} id={index} display = {close ? 'none' : 'inline-block'}>
              <HpPopup img={obj.img_url} link = {obj.landing_url} handlePopupClose = {handlePopupClose}  index = {index}/>
          </HpPopUpItemsBlock>
        )
    }
    // const getPopUpItem = () => {
    //     if(updatePopUp.length > 1){
    //         return (
    //             <HpPopUpContainer2Block>
    //                 <HpPopUpItem1Block display = {close1 ? 'none' : 'inline-block'}>
    //                     <HpPopup img={updatePopUp[0].img_url} link = {updatePopUp[0].landing_url} handlePopupClose = {handlePopupClose}  index = {0}/>
    //                 </HpPopUpItem1Block>
    //                 <HpPopUpItem2Block display = {close2 ? 'none' : 'inline-block'}>
    //                     <HpPopup img={updatePopUp[1].img_url} link = {updatePopUp[1].landing_url} handlePopupClose = {handlePopupClose}  index = {1}/>
    //                 </HpPopUpItem2Block>
    //             </HpPopUpContainer2Block>
    //         )
    //     }
    //     else if(updatePopUp.length > 0) {
    //         return (
    //                 <HpPopUpItem1Block display = {close1 ? 'none' : 'inline-block'}>
    //                     <HpPopup img={updatePopUp[0].img_url} link = {updatePopUp[0].landing_url} handlePopupClose = {handlePopupClose}  index = {0}/>
    //                 </HpPopUpItem1Block>
    //         )
    //     }
    // }
    return (
        <HpPopUpContainerBlock>
            {/*{getPopUpItem()}*/}
               {popUps}
        </HpPopUpContainerBlock>
    );
};

export default HpPopUpContainer;
